module.exports = __webpack_public_path__ + "media/components/application/PaymentCard/icons/maestro-cb002756cf9eed211022abc1c61421e7.svg";